exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dates[data-v-1f0065b2] {\n  justify-content: center;\n}\n.dates .cof-field[data-v-1f0065b2] {\n  margin: 0 50px;\n}\n.buttons[data-v-1f0065b2] {\n  justify-content: center;\n}\n.buttons .cof-field[data-v-1f0065b2] {\n  margin: 0 50px;\n}\n.btn.main[data-v-1f0065b2] {\n  background: #67C23A;\n  color: white;\n  padding: 0 16px;\n  font-size: 12px;\n  font-weight: bold;\n  border: 0;\n  box-sizing: border-box;\n  height: 29px;\n  border-radius: 15px;\n  font-size: 12px;\n  font-weight: bold;\n}\n.content-tlist[data-v-1f0065b2] {\n  border: none;\n}\n.content-filters .cof-box[data-v-1f0065b2] {\n  background: none;\n}", ""]);

// exports
